var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDbxenft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.997,
    height: 19.795,
    viewBox: "0 0 112.997 19.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M.178,19.433A.156.156,0,0,1,0,19.255V.178A.156.156,0,0,1,.178,0H5.162q4.387,0,6.572,2.06T13.914,8.4v2.285q0,4.481-2.18,6.614T5.162,19.433ZM1.3,18.275H5.1q3.8,0,5.65-1.824t1.855-5.712V8.333q0-3.71-1.855-5.445T5.1,1.153H1.3V18.269Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M36.178,19.433A.156.156,0,0,1,36,19.255V.178A.156.156,0,0,1,36.178,0h5.1a7.927,7.927,0,0,1,4.774,1.184,4.209,4.209,0,0,1,1.572,3.59,4.621,4.621,0,0,1-.844,2.846A4.8,4.8,0,0,1,44.16,9.25v.031A5.481,5.481,0,0,1,47.346,10.8a4.522,4.522,0,0,1,1.142,3.265A4.818,4.818,0,0,1,46.8,18.128q-1.69,1.3-5.461,1.3H36.173ZM37.3,8.841h4.507A4.879,4.879,0,0,0,45.15,7.8a3.646,3.646,0,0,0,1.174-2.877,3.266,3.266,0,0,0-1.263-2.877,7.025,7.025,0,0,0-3.988-.891H37.3Zm0,9.407H41.34a7.7,7.7,0,0,0,4.5-1.006,3.8,3.8,0,0,0,1.352-3.265A3.487,3.487,0,0,0,45.8,10.953,6.6,6.6,0,0,0,41.88,9.947H37.31v8.307Z",
    transform: "translate(-17.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M63.341,19.433a.13.13,0,0,1-.121-.058.138.138,0,0,1,.031-.147l6.824-9.79L63.608.21a.252.252,0,0,1-.016-.147c.01-.042.052-.058.131-.058h1.184a.219.219,0,0,1,.21.121l4.062,5.786c.278.414.566.839.875,1.274s.6.859.875,1.274h.031c.3-.435.6-.87.907-1.3s.608-.859.907-1.274l4-5.76A.262.262,0,0,1,76.988,0h1.158c.079,0,.126.021.131.058A.3.3,0,0,1,78.262.2L71.794,9.46l6.824,9.758a.151.151,0,0,1,.031.147c-.021.042-.058.058-.121.058H77.313a.269.269,0,0,1-.21-.121l-3.946-5.665c-.377-.535-.749-1.069-1.127-1.6s-.744-1.069-1.1-1.6H70.9q-.535.77-1.085,1.572t-1.085,1.541l-4,5.754a.279.279,0,0,1-.236.121H63.336Z",
    transform: "translate(-30.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M102.364,24.13a5.817,5.817,0,0,1-4.182-1.321,5.062,5.062,0,0,1-1.452-3.9V14.728a5.67,5.67,0,0,1,1.425-4.182A5.584,5.584,0,0,1,102.28,9.12a5.653,5.653,0,0,1,4.14,1.41,5.6,5.6,0,0,1,1.41,4.14v1.871a.156.156,0,0,1-.178.178H98.04v1.84a4.488,4.488,0,0,0,1.085,3.307,4.5,4.5,0,0,0,3.307,1.085,4.648,4.648,0,0,0,2.835-.728,2.394,2.394,0,0,0,.964-2.033.156.156,0,0,1,.178-.178h.98a.128.128,0,0,1,.147.147,3.324,3.324,0,0,1-1.289,2.893,6.318,6.318,0,0,1-3.873,1.085Zm-4.329-8.574h8.485v-.8a4.7,4.7,0,0,0-1.053-3.338,4.144,4.144,0,0,0-3.16-1.111,4.247,4.247,0,0,0-3.2,1.127,4.7,4.7,0,0,0-1.069,3.354v.77Z",
    transform: "translate(-46.036 -4.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M126.358,19.433a.156.156,0,0,1-.178-.178V.178A.156.156,0,0,1,126.358,0h1.693a.219.219,0,0,1,.21.121L135,11.514c.477.77.928,1.52,1.363,2.238s.854,1.431,1.263,2.123.807,1.384,1.2,2.075h.058V15.77c0-.723,0-1.452-.016-2.2s-.016-1.457-.016-2.149V.178A.156.156,0,0,1,139.025,0h.949a.156.156,0,0,1,.178.178V19.255a.156.156,0,0,1-.178.178h-1.661a.219.219,0,0,1-.21-.121L131.578,8.307q-.684-1.156-1.378-2.3c-.466-.76-.917-1.52-1.363-2.269s-.9-1.5-1.352-2.254h-.031V19.255c0,.121-.047.178-.147.178Z",
    transform: "translate(-60.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M164.008,19.433a.156.156,0,0,1-.178-.178V.178A.156.156,0,0,1,164.008,0H174.39a.156.156,0,0,1,.178.178v.859a.156.156,0,0,1-.178.178h-9.255v7.95h8.218a.156.156,0,0,1,.178.178v.828a.156.156,0,0,1-.178.178h-8.218v8.9a.156.156,0,0,1-.178.178h-.949Z",
    transform: "translate(-77.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M196.01,19.433a.156.156,0,0,1-.178-.178V1.216h-6c-.1,0-.147-.058-.147-.178V.178c0-.121.047-.178.147-.178H203.1a.156.156,0,0,1,.178.178v.859a.156.156,0,0,1-.178.178h-5.964V19.255a.156.156,0,0,1-.178.178h-.949Z",
    transform: "translate(-90.277)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1.263,
    cy: 1.263,
    r: 1.263,
    transform: "translate(5.398 8.621)",
    fill: "#f5b700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbxenft);
export default __webpack_public_path__ + "static/media/dbxenft.e29d8717581aca8ea44e48f9d3a52dae.svg";
export { ForwardRef as ReactComponent };